import React from 'react';
import { ThemeProvider, Theme } from '@mui/material';

import { supportUkraineTheme } from './theme';

type Props = {
  isActive?: boolean;
  overrideSecondaryColor?: boolean;
};

export const SupportUkraineTheme: React.FC<Props> = ({
  children,
  isActive = true,
  overrideSecondaryColor = true,
}) => (
  <ThemeProvider
    theme={(theme: Theme): Theme =>
      isActive ? supportUkraineTheme(theme, overrideSecondaryColor) : theme
    }
  >
    {children}
  </ThemeProvider>
);
